///////////////////////////////////////////////////////////////////77
import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
	type CarouselApi,
} from '@/app/shared/components';
import { StickerCollection } from '@/core/interfaces';
import { CollectionsCarouselItem } from '@/app/shared/components';
import { useEffect, useState } from 'react';
import { useCustomDispatch } from '@/core/redux/hooks';
import { setActiveCollection } from '@/core/redux/slices';
import { useNavigate } from 'react-router-dom';

interface CollectionsCarouselProps {
	collections: StickerCollection[];
	activeCollectionPosition: number;
	groupId: string;
}

export const CollectionsCarousel: React.FC<CollectionsCarouselProps> = ({
	activeCollectionPosition,
	collections,
	groupId,
}) => {
	const [api, setApi] = useState<CarouselApi>();
	const dispatch = useCustomDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		if (!api) {
			return;
		}

		api.on('select', () => {
			const collectionId = collections[api.selectedScrollSnap()].id;
			dispatch(
				setActiveCollection({
					groupId,
					collectionId,
				})
			);
			navigate(`/collections/${groupId}/${collectionId}`);
		});
	}, [api]);

	/*********************
	// #region Template
	**********************/
	return (
		<Carousel
			opts={{
				startIndex: activeCollectionPosition,
			}}
			setApi={setApi}
		>
			<CarouselContent>
				{collections &&
					collections.map((collection: StickerCollection) => {
						return (
							<CarouselItem key={collection.id}>
								<div className="flex flex-col ">
									<CollectionsCarouselItem
										collection={collection}
									/>
								</div>
							</CarouselItem>
						);
					})}
			</CarouselContent>
			<CarouselPrevious
				variant={'arrow'}
				className="-left-4 z-20 top-[220px]"
			/>
			<CarouselNext
				variant={'arrow'}
				className="-right-4 z-20 top-[220px]"
			/>
		</Carousel>
	);
};
